import axios from 'axios'

const config = {
	// requestUrl: process.env.NODE_ENV === 'production'?'path.json':'http://dj.gxsentu.net/request2/path.json', //动态域名所在地址
	baseUrl: 'http://zxzy.gxsentu.net/', // 接口域名，会被动态覆盖
	timeout:10000,
	// requestRemoteIp:() => { // 动态获取
	// 	return new Promise((resolve, reject) => {
	// 		axios.get(config.requestUrl,{t:new Date().getTime()}).then(response =>
	// 		{
	// 			if(response.status == 200){
	// 				config.baseUrl = response.data.http;
	// 				// sessionStorage.setItem('uploadImg',response.data.uploadImg)
	// 				resolve(response.data)
	// 			}
	// 		}, err => {
	// 			reject(err)
				
	// 		});
	// 	});
	// }
}

export default config


